import React, { Fragment, useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { GET_PONENCIAS, ADD_PONENCIA } from '../../graphql/actions/ponencia';
import axios from 'axios';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
// @material-ui/icons
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import CustomInput from '../UI/CustomInput/CustomInput';
import CustomFileInput from '../UI/CustomFileInput/CustomFileInput';
import Badge from '../UI/Badge/Badge';
import Button from '../UI/CustomButtons/Button';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
// Validations
import { isEmpty, countWords } from '../../util/validators';

import sectionAddStyle from '../../assets/jss/coscef/views/articuloSections/sectionAddStyle';

const url =
  process.env.NODE_ENV === 'development'
    ? 'http://100.100.100.248:4000/'
    : 'https://api.coscef.nat.cu/';

const useStyles = makeStyles(sectionAddStyle);

const PonenciaAdd = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();
  const [formTitulo, setFormTitulo] = useState('');
  const [formResumen, setFormResumen] = useState('');
  const [formFichero, setFormFichero] = useState('');
  const [singleFile, setSingleFile] = useState('');
  const [singleFileProgress, setSingleFileProgress] = useState(0);
  const [fileStatus, setFileStatus] = useState('Esperando fichero');
  const [fileStatusColor, setFileStatusColor] = useState('gray');
  const [addForm, setAddForm] = useState({
    titulo: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    resumen: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty, countWords({ min: 30, max: 38 })],
    },
    fichero: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);
  const [formIsFile, setFormIsFile] = useState(false);

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of addForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'titulo') {
        if (isValid) setFormTitulo('success');
        else setFormTitulo('error');
      }
      if (input === 'resumen') {
        if (isValid) setFormResumen('success');
        else setFormResumen('error');
      }
      if (input === 'fichero') {
        if (isValid) setFormFichero('success');
        else setFormFichero('error');
      }
    }

    const updatedForm = {
      ...addForm,
      [input]: {
        ...addForm[input],
        valid: isValid,
        value: value,
      },
    };

    let formIsValid = true;
    for (const inputName in updatedForm) {
      formIsValid = formIsValid && updatedForm[inputName].valid;
    }

    setAddForm(updatedForm);
    setFormIsValid(formIsValid);
  };

  const onFileInputChange = (inputFiles, inputFilesNames) => {
    //console.log(inputFiles[0], inputFilesNames);
    if (inputFiles[0]) {
      setSingleFile(inputFiles[0]);
      setFormIsFile(true);
    } else {
      setSingleFile('');
      setFormIsFile(false);
    }

    //inputChangedHandler(inputFiles[0], 'fichero');
  };

  const onFileUploadHandler = async () => {
    //console.log(singleFile);
    if (singleFile) {
      try {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            const percentage = Math.floor(
              ((loaded / 1000) * 100) / (total / 1000)
            );
            setSingleFileProgress(percentage);
          },
        };
        const formData = new FormData();
        formData.append('arch', singleFile);
        console.log(url + 'api/file/arch');
        const response = await axios.post(
          url + 'api/file/arch',
          formData,
          config
        );

        if (response.data) {
          //console.log(response.data);
          setFileStatus(response.data.message);
          setFileStatusColor('success');
          inputChangedHandler(response.data.url, 'fichero');
        }
      } catch (error) {
        console.log(error);
        setFileStatus(error.response.data.message);
        setFileStatusColor('danger');
      }
    }
  };

  const onFileDeleteHandler = async () => {
    //console.log(addForm.fichero.value);
    const arrayString = addForm.fichero.value.split('/');
    const filename = arrayString[arrayString.length - 1];

    if (filename) {
      try {
        const config = {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        };

        const response = await axios.delete(
          url + 'api/file/arch/' + filename,
          config
        );

        if (response.data) {
          setFileStatus(response.data.message);
          setFileStatusColor('success');
          inputChangedHandler('', 'fichero');
        }
      } catch (error) {
        setFileStatus(error.response.data.message);
        setFileStatusColor('danger');
      }
    }
  };

  const redirectToPonencias = (data) => {
    //console.log(data);
    if (data.createPonencia) props.history.push('/ponencias');
    else console.log('Error adicionando ponencia');
  };

  const updateCacheAdd = (cache, { data }) => {
    const { getPonencias } = cache.readQuery({
      query: GET_PONENCIAS,
      variables: {
        paginate: {
          numPonencias: 9,
          cursor: '',
          sortBy: { field: 'createdAt', order: 'ASC' },
        },
      },
    });

    const nuevaPonencia = data?.createPonencia;

    if (getPonencias && nuevaPonencia) {
      cache.writeQuery({
        query: GET_PONENCIAS,
        variables: {
          paginate: {
            numPonencias: 9,
            cursor: '',
            sortBy: { field: 'createdAt', order: 'ASC' },
          },
        },
        data: {
          getPonencias: {
            ponencias: [nuevaPonencia, ...getPonencias?.ponencias],
          },
        },
      });
    }
  };

  const [
    createPonencia,
    {
      loading: loadingAddPonencia,
      error: errorAddPonencia,
      data: dataAddPonencia,
    },
  ] = useMutation(ADD_PONENCIA, {
    errorPolicy: 'all',
    update: updateCacheAdd,
    onCompleted: (data) => redirectToPonencias(data),
  });

  const adicionarHandler = (event) => {
    event.preventDefault();

    const ponenciaData = {};
    for (let i in addForm) {
      ponenciaData[i] = addForm[i].value;
    }

    createPonencia({
      variables: {
        input: {
          titulo: ponenciaData.titulo,
          resumen: ponenciaData.resumen,
          fichero: ponenciaData.fichero,
        },
      },
    });

    //console.log(ponenciaData);
  };

  let seccionTitulo = (
    <div className={classes.section}>
      <GridContainer justify='center'>
        <GridItem xs={12} sm={8} md={8}>
          <h2 className={classes.title}>Crear Ponencia</h2>
        </GridItem>
      </GridContainer>
    </div>
  );

  let seccionButton = (
    <GridContainer>
      <GridItem
        md={4}
        sm={4}
        className={classNames(
          classes.mrAuto,
          classes.mlAuto,
          classes.textCenter
        )}
      >
        <Button type='submit' color='dark' round disabled={!formIsValid}>
          Crear Ponencia
        </Button>
      </GridItem>
    </GridContainer>
  );

  let seccionFormulario = (
    <div id='formularioAdd'>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <form onSubmit={adicionarHandler}>
            <GridContainer>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Título (*)'
                  success={formTitulo === 'success'}
                  error={formTitulo === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'titulo');
                    },
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Resumen (De 30 a 38 palabras)'
                  success={formResumen === 'success'}
                  error={formResumen === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'resumen');
                    },
                    multiline: true,
                    rows: 6,
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <div className={classes.control}>
                  <CustomFileInput
                    id={'arch'}
                    onChange={onFileInputChange}
                    success={formFichero === 'success'}
                    error={formFichero === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      placeholder: 'Cargar Ponencia (*)',
                    }}
                  />
                  <div>
                    <div className={classes.circleBar}>
                      <CircularProgressbar
                        value={singleFileProgress}
                        text={`${singleFileProgress}%`}
                        style={buildStyles({
                          rotation: 0.25,
                          strokeLinecap: 'butt',
                          textSize: '12px',
                          pathTransitionDuration: 0.5,
                          pathColor: `rgb(62, 152, 199, ${
                            singleFileProgress / 100
                          })`,
                          textColor: '#4caf50',
                          trailColor: '#d6d6d6',
                          backgroundColor: '#dff0d8',
                        })}
                      />
                    </div>
                    <Badge
                      className={classes.marginLeft20}
                      color={fileStatusColor}
                    >
                      {fileStatus}
                    </Badge>
                    <Button
                      color='dark'
                      round
                      justIcon
                      simple
                      disabled={!addForm.fichero.value}
                      onClick={onFileDeleteHandler}
                    >
                      <i className='fa fa-trash' />
                    </Button>
                    <Button
                      color='dark'
                      round
                      className={classes.floatRight}
                      disabled={!formIsFile}
                      onClick={onFileUploadHandler}
                    >
                      Subir Ponencia
                    </Button>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
            {seccionButton}
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
  let showNotification = null;

  if (loadingAddPonencia) seccionButton = <Spinner color='gray' />;

  if (errorAddPonencia) {
    showNotification = errorAddPonencia.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorAddPonencia ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataAddPonencia && dataAddPonencia.createPonencia) {
    const { createPonencia } = dataAddPonencia;
    if (createPonencia.success && createPonencia.code === '201') {
      showNotification = (
        <Notification
          key={createPonencia.code}
          mostrar={createPonencia.success ? true : false}
          msg={createPonencia.message}
          stt={createPonencia.success}
        />
      );
    }
  }

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <div className={classes.sections}>
          <div className={classes.sectionWhite}>
            <div>
              <div className={classes.container}>
                {seccionTitulo}
                <div className={classes.marginTop35}>{seccionFormulario}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default withRouter(PonenciaAdd);
